module.exports = "<div class=c-app-popover ng-transclude=apps> </div> ";